var map = {
	"./arrow.png": "8bd9",
	"./class.png": "b1f0",
	"./extend.png": "7e4c",
	"./follow.png": "57ef",
	"./func.png": "ea6e",
	"./mouse.png": "3de0",
	"./new.png": "bd7a",
	"./point.png": "3e2f",
	"./pointF.png": "a835",
	"./redo.png": "9297",
	"./undo.png": "3e49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2493";